<mat-toolbar>
	<div style="display: flex; flex-direction: row; justify-content: flex-start; align-items: center; gap: 20px">
		<button mat-icon-button (click)="toggleMenu.emit()">
			<mat-icon style="color: #e1dfe6">menu</mat-icon>
		</button>
		@if (!viewMobile) {
			<img src="/assets/images/logo_wit.png" style="height: 36px; cursor: pointer" (click)="home()" />
		}
	</div>
	<span class="toolbar-spacer"></span>
	<div style="display: flex; flex-direction: row; justify-content: flex-start; align-items: center; gap: 20px">
		<div *ngIf="!viewMobile && isOperator" style="display: flex; gap: 20px">
			<button 
				mat-flat-button 
				[routerLink]="['/voucher/new']" 
				color="accent" 
				[disabled]="isBlocked$ | async" 
				[matTooltip]="(isBlocked$ | async) ? ('SUBSCRIPTION.EXPIRED_MESSAGE' | translate) : ''"
			>
				<mat-icon *ngIf="isBlocked$ | async" class="blocked-icon">block</mat-icon>
				<mat-icon *ngIf="!(isBlocked$ | async)">receipt</mat-icon>
				{{ 'APPLICATION.add_voucher' | translate | capitalize }}
			</button>
			<button 
				mat-flat-button 
				[routerLink]="['/booking/new']" 
				color="accent" 
				[disabled]="isBlocked$ | async" 
				[matTooltip]="(isBlocked$ | async) ? ('SUBSCRIPTION.EXPIRED_MESSAGE' | translate) : ''"
			>
				<mat-icon *ngIf="isBlocked$ | async" class="blocked-icon">block</mat-icon>
				<mat-icon *ngIf="!(isBlocked$ | async)">perm_contact_calendar</mat-icon>
				{{ 'APPLICATION.add_booking' | translate | capitalize }}
			</button>
			<button 
				mat-flat-button 
				[routerLink]="['/flight/new']" 
				color="accent" 
				[disabled]="isBlocked$ | async" 
				[matTooltip]="(isBlocked$ | async) ? ('SUBSCRIPTION.EXPIRED_MESSAGE' | translate) : ''"
			>
				<mat-icon *ngIf="isBlocked$ | async" class="blocked-icon">block</mat-icon>
				<mat-icon *ngIf="!(isBlocked$ | async)">flight_takeoff</mat-icon>
				{{ 'APPLICATION.add_flight' | translate | capitalize }}
			</button>
		</div>
		<div>{{ tenant | uppercase }}</div>
		<div style="display: flex; flex-direction: row; align-items: center">
			<button *ngIf="viewMobile && isOperator && drawerStatus" mat-mini-fab (click)="toggleDrawerStatus()">
				<mat-icon aria-hidden="false" [matBadge]="unreadSms" matBadgeColor="accent" [matBadgeHidden]="unreadSms === 0">sms</mat-icon>
			</button>
			<button *ngIf="viewMobile && isOperator && !drawerStatus" mat-icon-button (click)="toggleDrawerStatus()">
				<mat-icon
					style="color: #e1dfe6"
					aria-hidden="false"
					[matBadge]="unreadSms"
					matBadgeColor="accent"
					[matBadgeHidden]="unreadSms === 0"
					>sms</mat-icon
				>
			</button>
			<!-- 235: messages (desktop) — replaces the floating "MSG" tab; same badge, opens the message drawer -->
			<button
				*ngIf="!viewMobile && isOperator"
				mat-icon-button
				(click)="toggleMessages.emit()"
				[matTooltip]="'APPLICATION.messages' | translate | capitalize"
				[attr.aria-label]="'APPLICATION.messages' | translate | capitalize"
			>
				<mat-icon style="color: #e1dfe6" aria-hidden="false" [matBadge]="unreadSms" matBadgeColor="accent" [matBadgeHidden]="!unreadSms"
					>forum</mat-icon
				>
			</button>
			<button *ngIf="!viewMobile" mat-icon-button (click)="getHelp()">
				<mat-icon style="color: #e1dfe6">help</mat-icon>
			</button>
			<button mat-icon-button [matMenuTriggerFor]="dropdownMenu">
				<mat-icon style="color: #e1dfe6">account_circle</mat-icon>
			</button>
		</div>
	</div>
</mat-toolbar>
<mat-menu #dropdownMenu x-position="before">
	@if (authenticated) {
		<a mat-menu-item href="" (click)="logout()">
			<mat-icon>logout</mat-icon>
			<span>{{ 'APPLICATION.sign_out' | translate | capitalize }}</span>
		</a>
		<a mat-menu-item (click)="forgetDeviceId()">
			<mat-icon>logout</mat-icon>
			<span>{{ 'VALIDATIONS.forget_device' | translate | capitalize }}</span>
		</a>
		<!-- SHOW RELEASE NOTES -->
		@if (themeService.darkEnabled) {
			<button mat-menu-item [matMenuTriggerFor]="themeMenu"><mat-icon>contrast</mat-icon>{{ 'WEEKPLANNER.theme.title' | translate }}</button>
		}
		<a mat-menu-item (click)="showReleaseNotes()">
			<mat-icon>open_in_browser</mat-icon>
			<span>{{ 'VALIDATIONS.show_new_features' | translate | capitalize }}</span>
		</a>
		<div mat-menu-item>Version {{ currentAppVersion }}</div>
	} @else {
		<a mat-menu-item href="" (click)="login()">
			<mat-icon>login</mat-icon>
			<span>{{ 'APPLICATION.sign_in' | translate | capitalize }}</span>
		</a>
	}
</mat-menu>
<!-- 228 US9: theme preference -->
<mat-menu #themeMenu="matMenu">
	@for (option of ['light', 'dark', 'system']; track option) {
		<button mat-menu-item (click)="setTheme($any(option))">
			<mat-icon>{{ themeService.preference === option ? 'radio_button_checked' : 'radio_button_unchecked' }}</mat-icon>
			{{ 'WEEKPLANNER.theme.' + option | translate }}
		</button>
	}
</mat-menu>
